import { Flex, FlexProps, Heading } from 'yoso';
import { BaseCard } from '~/components/Card';
import { T } from '~/components/I18n';
import { Boost } from '~/components/Icon/Boost';
import styles from './EvolveBanner.module.scss';

export const EvolveBanner = () => (
  <BaseCard<FlexProps> as={Flex} container alignItems="center" className={styles.root} size="large">
    <Heading level={5} className={styles.heading}>
      <T name="citizen_evolve_bonus_title" />
    </Heading>
    <p className={styles.description}>
      <T name="citizen_evolve_howto_desc4" />
    </p>
    <Boost className={styles.icon} />
  </BaseCard>
);
